module.exports = __webpack_public_path__ + "static/converge1-fec64ab9b46d533f39bfb534fd6ba100.jpg";